const config = {
  API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? 'http://ec2-3-144-89-13.us-east-2.compute.amazonaws.com'
    : 'http://localhost:5000'
};

export default config; 